import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_af92w55rjq: FaireBrandEntity = {
  token: "b_af92w55rjq",
  type: "brand",
  name: "Steele Sloan Designs",
  avatarUrl:
    "https://cdn.faire.com/fastly/ef2be52b4a6a0085d92040e5ba4576ffa98e1d76864af3dd85b454dd5c9d5707.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c82a2e19af566e143977a354613f5dc6292d8f78272c88648cef8d049f290358.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ef2be52b4a6a0085d92040e5ba4576ffa98e1d76864af3dd85b454dd5c9d5707.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c82a2e19af566e143977a354613f5dc6292d8f78272c88648cef8d049f290358.jpeg",
  location: "Atlanta, GA, USA",
  minimumOrderDollars: 120,
  rating: 5,
  reviewCount: 243,
  isTopShop: true,
  isInsider: true,
  description:
    'Hi! I\'m Theresa and I am based out of the Buckhead neighborhood in Atlanta, GA -  My goal is to be your FAVORITE Shop for the latest Gift Ideas for Jewelry Styles and Jewelry Trends at great prices and great quality -  I want to be your "Go To" shop where you know you will find that PERFECT piece of jewelry you are looking for - whether it is for a birthday gift, gift for you, the perfect game day necklace, college graduation, what to wear on game day, keeping up with the latest styles and trends and keeping you looking FABULOUS - My "go to" material is stainless steel, as it gives you a great look at a great price point with the added benefit of being hypoallergenic for sensitive ears :)  We are also continuing to add more collegiate officially licensed products!\n\nMy goal is for people to stop you and say "Where did you get that gorgeous necklace....bracelet.... ring!  Steele Sloan Designs!! :) \n\nThank you SO much for stopping by - I hope you find what  you love!  ',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:16.005Z",
    importedBy: "entity-db-cli",
  },
};
